module.exports = __webpack_public_path__ + "assets/img/D2.adada35b.png";